import React from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const defaultButton = (props) => <button {...props}>{props.children}</button>;

export default class Pagination extends React.Component {
  constructor(props) {
    super();

    this.state = {
      pageSize:  props.pageSize || 5,
      page: props.page || 0
    };
  }

  render() {
    const { PageButtonComponent = defaultButton } = this.props;

    const setPageSize = (pageSize) => {
      this.setState({ pageSize });
      this.props.setPageSize(pageSize);
    }

    const setPage = (page) => {
      this.setState({ page });
      this.props.setPage(page);
    }

    const page = this.props.getPage();
    const pageSize = this.props.getPageSize();

    const canShowPrevious = page > 0;
    const canShowNext = this.props.hasMoreItems(page, pageSize);

    return (
      <div className="page">
        <div className="rowsper-page">
          <p>Rows Per Page:</p>
          <Dropdown
            className="page-dropdown"
            isOpen={this.state.showPageSizeDropdown}
            toggle={() => this.setState({ showPageSizeDropdown: !this.state.showPageSizeDropdown})}
          >
            <DropdownToggle caret>{pageSize}</DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => setPageSize(5)}>5</DropdownItem>
              <DropdownItem onClick={() => setPageSize(10)}>10</DropdownItem>
              <DropdownItem onClick={() => setPageSize(25)}>25</DropdownItem>
              <DropdownItem onClick={() => setPageSize(50)}>50</DropdownItem>
              <DropdownItem onClick={() => setPageSize(100)}>100</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        
        <div className="page-items">
          <p>
            <label>{Math.max(1, page * pageSize)} - {(page + 1) * pageSize}</label>
            <PageButtonComponent
              className="Table__pageButton fa fa-angle-left arrow-btns"
              onClick={() => setPage(page - 1)}
              disabled={!canShowPrevious}
            />
            <PageButtonComponent
              className="Table__pageButton fa fa-angle-right arrow-btns"
              onClick={() => setPage(page + 1)}
              disabled={!canShowNext}
            />
          </p>
        </div>
      </div>
    );
  }
}
